import { canApproveForm } from '../onboarding-action-policy.service';
import templateUrl from './nc-w4.component.html';
import moment from 'moment';
import { PreviewSignatureModal } from '../preview-signature-modal/preview-signature-modal.component';
import { InfoModal } from '../info-modal/info-modal.component';
import { OwnerPreviewSignatureModal } from '../preview-signature-modal/owner-preview-signature-modal.component';

// North Carolina NC-4 EZ (StateProvinceID 35, requestTypeId 2).
// Cloned from nj-w4; NC-4 EZ is an employee-only certificate (no employer section),
// SSN and legal name are split across comb boxes, filing status is a radio (s/h/m),
// and the exemption certifications are checkboxes whose PDF on-value is "Yes".
const NC_STATE_ID = 35;

export const NcW4Component = {
    templateUrl,
    controller: NcW4Controller,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        ownerView: "<",
        owner: "<",
        employee: "<",
        employeeProfile: "<",
        profile: "<",
        employeeBankInfo: "<",
        provinces: "<",
        application: "<",
        genderOptions: "<",
        userInputs: "<",
        savedInputs: "<",
        maritalStatus: "<",
        addlInputs: "<",
        ownerInfo: "<",
        stateTaxInfo: "<",
        showSignaturePopup: "<",
        close: "&",
        dismiss: "&"
    }
};

function NcW4Controller(onboardingActionPolicy, onboardingDocumentService, $state, $scope, $uibModal, $q, utilityService, localeService, onboardingDocumentViewService, employeeService) {
    'ngInject';
    const vm = this;
    // APEX-977: read-only View mode (locked forms) - hides inline Edit, keeps fields disabled.
    vm.isViewOnly = () => !!vm.application && onboardingActionPolicy.getButtonTitle('2', vm.application) === 'View';
    vm.taxForm;

    vm.onPreview = onPreview;
    vm.onPreviewInPage = onPreviewInPage;
    vm.onDocDownload = onDocDownload;
    vm.onSubmit = onSubmit;
    vm.onShowI9 = onShowI9;
    vm.onClose = onClose;
    vm.onRequestReview = onRequestReview;
    vm.onSave = onSave;
    vm.revealSSNChar = revealSSNChar;
    vm.formatSsn = formatSsn;
    vm.retrieveLocale = retrieveLocale;
    vm.retrieveLocaleTranslations = retrieveLocaleTranslations;
    vm.syncFormToProfile = syncFormToProfile;
    vm.stateWitholdingTypeID = 5;
    vm.reqReview = false;
    vm.isSigned = false;
    vm.prefilled = false;
    vm.editable = true;
    vm.disableEmpFields = true;
    vm.disableEmprFields = false;
    vm.isSaved = false;
    vm.savedData = false;
    vm.showSavedNotification = false;
    vm.previewUrl;
    vm.fillLockedInfo = fillLockedInfo;
    vm.onEditClicked = onEditClicked;
    vm.onClaimToggle = onClaimToggle;
    vm.onRevokeToggle = onRevokeToggle;
    vm.state = { view: 'W4' };

    // NC-4 EZ filing-status radio -> Apex marital-status used for the withholding record.
    // s = Single/MFS, h = Head of Household, m = Married Filing Jointly / Surviving Spouse.
    vm.filingStatusMapping = [
        { value: 's', maritalStatus: 'S' },
        { value: 'h', maritalStatus: 'H' },
        { value: 'm', maritalStatus: 'MC' }
    ];
    vm.maritalStatusMapping = [
        { id: 4, status: 'S', label: 'Single' },
        { id: 13, status: 'MC', label: 'Married Filing Jointly or Surviving Spouse' },
        { id: 6, status: 'H', label: 'Head of Household' }];

    vm.$onInit = function () {
        if (vm.resolve) {
            Object.assign(vm, vm.resolve);
        }
        vm.reqReview = false;
        vm.date = moment(new Date(), 'MM/DD/YYYY').toDate();
        vm.stateProvinces = this.provinces;
        vm.userProfile = this.profile;

        vm.retrieveLocale()
            .then(function (locale) {
                return vm.retrieveLocaleTranslations(locale.localeID);
            })
            .then(function (translations) {
                vm.employeeBankInfo.Translations = translations;
            });

        if (vm.savedInputs != null && vm.savedInputs.EmployeeLastName != null && !vm.ownerView) {
            vm.savedData = true;
            vm.showSavedNotification = true;
            fillEmployee(vm.savedInputs);
        } else if (vm.userInputs != null && vm.userInputs.EmployeeLastName != null) {
            if (this.application) {
                vm.editable = !(this.application && this.application.HasSW4Form !== null && this.application.ProvinceW4 !== 'Review' && this.application.ProvinceW4 !== 'Submitted' && this.application.ProvinceW4 !== 'Pending');
            }
            fillEmployee(vm.userInputs);
            if (vm.application.ProvinceW4 === "Pending") {
                fillLockedInfo();
            }
        } else {
            prefillFromProfile();
        }

        if (vm.application.ApplicationStatus === 'Approved' || vm.application.ApplicationStatus === 'Submitted') {
            vm.editable = false;
        }
        if (vm.ownerView && vm.showSignaturePopup) {
            return onPreview();
        }
        vm.editable = resolveEditable();
    }

    function resolveEditable() {
        const appStatus = vm.application.ApplicationStatus;
        const formStatus = vm.application.ProvinceW4;
        if (formStatus === 'ReviewRequired') return true;
        if (appStatus === 'Approved' || appStatus === 'Submitted') return false;
        if (formStatus === 'Submitted' || formStatus === 'Approved') return false;
        if (appStatus === 'Pending') {
            return formStatus === 'Pending' || vm.application.EmployeeStatus !== 'Pending';
        }
        return !vm.application.HasSW4Form
            || formStatus === 'Pending'
            || formStatus === 'ReviewRequired';
    }

    function splitSsn(ssn) {
        const d = (ssn || '').replace(/[^0-9]/g, '');
        return { p1: d.substring(0, 3), p2: d.substring(3, 5), p3: d.substring(5, 9) };
    }

    function prefillFromProfile() {
        vm.firstName = vm.employeeProfile.FirstName;
        vm.middleInitial = (vm.employeeProfile.MiddleName || '').substring(0, 1);
        vm.lastName = vm.employeeProfile.LastName;
        vm.employeeSsn = vm.employeeBankInfo.CurrentSSN;
        vm.address = [vm.profile.HomeAddress.StreetLine1, vm.profile.HomeAddress.StreetLine2, vm.profile.HomeAddress.AptNum].filter(Boolean).join(', ');
        vm.city = vm.profile.HomeAddress.City;
        vm.stateProvince = vm.stateProvinces.find(x => x.StateProvinceID === vm.profile.HomeAddress?.StateProvinceID);
        vm.zipCode = vm.profile.HomeAddress.PostalCode;
        //vm.country = vm.profile.HomeAddress.CountryName || '';
    }

    function fillLockedInfo() {
        prefillFromProfile();
    }

    function onEditClicked() {
        vm.editable = !vm.editable;
        if (vm.employeeProfile != null && vm.employeeProfile.EmployeeStatusID === 1 && vm.application.ApplicationStatus === 'Pending') {
            prefillFromProfile();
        }
    }

    // Retrieved user-input values come back as strings; numeric inputs (type=number)
    // must be coerced or Angular throws "Expected x to be a number".
    function toNumOrNull(v) {
        return v != null && v !== '' ? Number(v) : null;
    }

    // Claim (lines 3-5) and revoke (step 6) are mutually exclusive. Claiming requires the year;
    // revoking requires >=1 of the line3/4/5 sub-boxes and clears the year.
    function onClaimToggle() {
        if (vm.exempt1 || vm.exempt2 || vm.exempt3) {
            vm.exemptRevoke = false;
            vm.revokeLine3 = false; vm.revokeLine4 = false; vm.revokeLine5 = false;
        }
    }
    function onRevokeToggle() {
        if (vm.exemptRevoke) {
            vm.exempt1 = false; vm.exempt2 = false; vm.exempt3 = false;
            vm.exemptionYear = null;
        } else {
            vm.revokeLine3 = false; vm.revokeLine4 = false; vm.revokeLine5 = false;
        }
    }

    function fillEmployee(data) {
        vm.firstName = data.EmployeeFirstName;
        vm.middleInitial = data.EmployeeMiddleInitial;
        vm.lastName = data.EmployeeLastName;
        vm.employeeSsn = vm.employeeBankInfo.CurrentSSN;
        vm.address = data.EmployeeAddress || [vm.profile.HomeAddress.StreetLine1, vm.profile.HomeAddress.StreetLine2, vm.profile.HomeAddress.AptNum].filter(Boolean).join(', ');
        vm.county = data.EmployeeCounty;
        vm.city = data.EmployeeCity;
        vm.stateProvince = vm.stateProvinces.find(x => x.Abbr === data.EmployeeState)
            || vm.stateProvinces.find(x => x.StateProvinceID === vm.employeeBankInfo?.StateToBeTaxedIn);
        vm.zipCode = data.EmployeeZip;
        vm.country = data.EmployeeCountry;
        vm.filingStatus = data.FilingStatus;
        vm.totalAllowances = toNumOrNull(data.TotalAllowances);
        vm.addlAmount = toNumOrNull(data.AdditionalStateWithholding);
        vm.exemptionYear = toNumOrNull(data.ExemptionYear);
        vm.exempt1 = data.Exempt1 === 'Yes';
        vm.exempt2 = data.Exempt2 === 'Yes';
        vm.exempt3 = data.Exempt3 === 'Yes';
        vm.exemptRevoke = data.ExemptRevoke === 'Yes';
        vm.revokeLine3 = data.RevokeLine3 === 'Yes';
        vm.revokeLine4 = data.RevokeLine4 === 'Yes';
        vm.revokeLine5 = data.RevokeLine5 === 'Yes';
        if (data.Signature) {
            vm.signimage = data.Signature;
            vm.isSigned = true;
        }
        vm.prefilled = true;
        vm.date = moment(data.Date, 'MM/DD/YYYY').toDate();
    }

    // Single source of truth for the POST payload. FormRequest is all-string, so every
    // value is stringified (JSON numbers do not bind -> numeric fields arrive null).
    // Checkboxes send the PDF on/off literals "Yes"/"Off".
    function buildFormData(includeSignature) {
        const s = (v) => (v == null ? '' : String(v));
        const ssnParts = splitSsn(vm.employeeSsn || (vm.employeeBankInfo && vm.employeeBankInfo.CurrentSSN));
        const formData = {
            RequestTypeId: '2',
            IsI9EmployeeMode: !vm.ownerView,
            EmployeeFirstName: s(vm.firstName),
            EmployeeMiddleInitial: s(vm.middleInitial),
            EmployeeLastName: s(vm.lastName),
            EmployeeSSN1: s(ssnParts.p1),
            EmployeeSSN2: s(ssnParts.p2),
            EmployeeSSN3: s(ssnParts.p3),
            EmployeeAddress: s(vm.address),
            EmployeeCounty: s(vm.county),
            EmployeeCity: s(vm.city),
            EmployeeState: s(vm.stateProvince ? vm.stateProvince.Abbr : ''),
            EmployeeZip: s(vm.zipCode),
            EmployeeCountry: s(vm.country),
            FilingStatus: s(vm.filingStatus),
            TotalAllowances: s(vm.totalAllowances != null ? vm.totalAllowances : ''),
            AdditionalStateWithholding: s(vm.addlAmount != null && vm.addlAmount !== '' ? Math.trunc(Number(vm.addlAmount)) : ''),
            ExemptionYear: s(vm.exemptionYear != null ? vm.exemptionYear : ''),
            Exempt1: vm.exempt1 ? 'Yes' : 'Off',
            Exempt2: vm.exempt2 ? 'Yes' : 'Off',
            Exempt3: vm.exempt3 ? 'Yes' : 'Off',
            ExemptRevoke: vm.exemptRevoke ? 'Yes' : 'Off',
            RevokeLine3: (vm.exemptRevoke && vm.revokeLine3) ? 'Yes' : 'Off',
            RevokeLine4: (vm.exemptRevoke && vm.revokeLine4) ? 'Yes' : 'Off',
            RevokeLine5: (vm.exemptRevoke && vm.revokeLine5) ? 'Yes' : 'Off',
            Date: moment(vm.date, 'MM/DD/YYYY').format('MM/DD/YYYY'),
            Signature: includeSignature ? vm.signimage : undefined
        };
        return formData;
    }

    $scope.$watch('vm.taxForm.$dirty', function (value) {
        if (value) {
            vm.prefilled = false;
        }
    }, false);

    function onRequestReview() {
        const trans = onboardingDocumentService.saveComment({
            ApplicationId: vm.application.ApplicationId,
            UserName: vm.owner.UserName,
            Text: vm.commentText,
        }).then((res) => {
            if (res) return onboardingDocumentService.setReviewRequired(vm.employee.EmployeeID, '2');
        }).then(() => {
            vm.close({ $value: 'ok' });
        }).catch((err) => {
            return $q.reject(err);
        });
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, 'Request review failed')
        );
    }

    function onDocDownload(pages) {
        utilityService.showLoading();
        return onboardingDocumentService.retrieveTemplate(vm.employee.UserName, '1', String(NC_STATE_ID), pages).then(function (result) {
            utilityService.hideLoading();
            return result;
        }).then(function () {
            utilityService.hideLoading();
        });
    }

    // Writes the NC-4 EZ election into the employee's New-Hires-File bank-info columns (Z-AF):
    //   Z  State Marital Status          <- Filing Status (s/h/m)
    //   AA Total State Allowances        <- Step 1 (Line 1 total allowances)
    //   AB Dependent Allowances          <- not on NC-4 EZ (left untouched)
    //   AC Additional Depend Allowances  <- not on NC-4 EZ (left untouched)
    //   AD Adopted Child Allowances      <- not on NC-4 EZ (left untouched)
    //   AE State Withholding Amount (S)  <- Step 2 (Line 2 additional amount), withholding type 5 'S'
    //   AF State Exempt                  <- Step 3, 4, or 5 (any exemption claimed)
    function syncFormToProfile() {
        // Z: State Marital Status <- filing status (s/h/m -> S/H/MC -> MaritalStatusID). Mirrors MD mapping pattern.
        const fs = vm.filingStatusMapping.find(function (x) {
            return x.value === vm.filingStatus;
        });
        const status = fs ? fs.maritalStatus : null;
        const mapped = vm.maritalStatusMapping.find(function (x) {
            return x.status === status;
        });
        const mappedId = mapped ? mapped.id : null;
        if (mappedId != null && Array.isArray(vm.maritalStatus)) {
            const match = vm.maritalStatus.find(function (item) {
                return item.MaritalStatusID === mappedId;
            });
            if (match) {
                vm.employeeBankInfo.StateMaritalStatusID = match.MaritalStatusID;
                vm.employeeBankInfo.StateMaritalStatusParams = mapped.label;
            }
        }

        // AA: Total State Allowances <- Line 1
        vm.employeeBankInfo.RegularWithholdingAllowances = vm.totalAllowances;

        // AE: State Withholding Amount (S) <- Line 2 (whole dollars), withholding type 5 'S'
        vm.employeeBankInfo.EmployeeWithholdingInfos = vm.employeeBankInfo.EmployeeWithholdingInfos.filter(function (x) {
            return x.WithholdingTypeID !== vm.stateWitholdingTypeID;
        });
        if (vm.addlAmount != null && vm.addlAmount !== '') {
            vm.employeeBankInfo.EmployeeWithholdingInfos.push({
                EmployeeId: vm.employee.EmployeeID,
                WithholdingTypeID: vm.stateWitholdingTypeID,
                AdditionalWithholdingAmount: Math.trunc(Number(vm.addlAmount))
            });
        }

        // AF: State Exempt <- any of Step 3/4/5 (revoking clears these, so revoke => not exempt)
        vm.employeeBankInfo.StateTaxExempt = !!(vm.exempt1 || vm.exempt2 || vm.exempt3);

        // AB/AC/AD (Dependent / Additional Dependent / Adopted Child Allowances) are not on the
        // NC-4 EZ and are intentionally left untouched.
    }

    function onPreviewInPage() {
        if (vm.taxForm && vm.taxForm.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return;
        }
        utilityService.showLoading();
        const formData = buildFormData(false);
        return onboardingDocumentService.previewUrl(vm.employee.UserName, formData, NC_STATE_ID)
            .then(function (result) {
                utilityService.hideLoading();
                vm.previewUrl = result;
                return $uibModal.open({
                    ...PreviewSignatureModal,
                    resolve: {
                        title: () => "North Carolina NC-4 EZ",
                        previewUrl: () => vm.previewUrl
                    }
                }).result;
            }).then(function (data) {
                if (!data || !data.dataUrl) {
                    utilityService.hideLoading(); return;
                }
                vm.signimage = data.dataUrl;
                vm.isSigned = data.dataUrl != null;
                return onSubmit();
            }).catch((err) => {
                console.log(err);
                utilityService.hideLoading();
            });
    }

    function onSave() {
        utilityService.showLoading();
        const formData = buildFormData(false);
        return onboardingDocumentService.save(vm.employee.UserName, formData, NC_STATE_ID).then(function () {
            vm.isSaved = true;
            vm.showSavedNotification = true;
            vm.taxForm.$setPristine();
            return utilityService.hideLoading();
        }).catch(function (err) {
            console.log(err);
            return utilityService.hideLoading();
        });
    }

    function onApprove() {
        const approvePromise = onboardingDocumentService.approveOnboardingForm(vm.application.ApplicationId, "2");
        const trans = $q.all(approvePromise).then((res) => {
            vm.onShowI9();
        }).catch((err) => {
            return $q.reject(err);
        });
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, "Approve failed")
        );
    }

    function onSubmit() {
        if (vm.taxForm && vm.taxForm.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return;
        }
        const updatePromises = [];
        vm.isDirtyEdit = vm.employeeProfile != null && vm.employeeProfile.EmployeeStatusID !== 2 && vm.application.ApplicationStatus === 'Pending';
        const isPendingResubmit = vm.application.ApplicationStatus === 'Pending' && (vm.application.ProvinceW4 === 'Approved' || vm.application.ProvinceW4 === 'Pending');
        if ((vm.taxForm && vm.taxForm.$dirty) || vm.savedData || vm.isSaved || vm.ownerView || vm.isDirtyEdit || isPendingResubmit || vm.isSigned || vm.application.ProvinceW4 === 'ReviewRequired') {
            if (!vm.isSigned) {
                utilityService.hideLoading();
                alert("Preview and Signature are required");
            }
            if (!vm.signimage) {
                utilityService.hideLoading();
                alert("Signature is required");
                return;
            }
            const formData = buildFormData(true);
            if (!vm.ownerView) {
                syncFormToProfile();
                updatePromises.push(() => employeeService.updateEmployeeOnboardingBankInfo(vm.employee.EmployeeID, vm.employeeBankInfo));
            }
            updatePromises.push(() => onboardingDocumentService.submit(vm.employee.UserName, formData, NC_STATE_ID));
        }
        if (!Array.isArray(updatePromises) || updatePromises.length === 0) {
            if (vm.ownerView) {
                return onApprove();
            } else {
                return onShowI9();
            }
        }
        const trans = updatePromises.reduce((chain, promise) => {
            return chain.then(() => (typeof promise === 'function' ? promise() : promise));
        }, $q.resolve()).then((res) => {
            if (vm.ownerView) {
                return onApprove();
            } else {
                return onShowI9();
            }
        }).catch((err) => {
            return $q.reject(err);
        });
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, "Save failed")
        );
    }

    function onPreview() {
        if (vm.taxForm && vm.taxForm.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return;
        }
        utilityService.showLoading();
        const formData = buildFormData(true);
        return onboardingDocumentService.previewUrl(vm.employee.UserName, formData, NC_STATE_ID)
            .then(function (result) {
                utilityService.hideLoading();
                vm.previewUrl = result;
                return $uibModal.open({
                    ...OwnerPreviewSignatureModal,
                    resolve: {
                        title: () => "North Carolina NC-4 EZ",
                        previewUrl: () => vm.previewUrl,
                        allowApprove: () => canApproveForm(vm.application, '2'),
                        allowSign: () => false,
                        showSignaturePopup: () => vm.showSignaturePopup
                    }
                }).result;
            }).then(function (data) {
                if (data === 'terminate' && vm.showSignaturePopup) {
                    return vm.close({ $value: 'ok' });
                }
                if (data && data.success) {
                    vm.employerSignimage = data.dataUrl;
                    vm.isSigned = true;
                    return onSubmit();
                }
            }).catch((err) => {
                console.log(err);
                utilityService.hideLoading();
            });
    }

    $scope.$on('modal.closing', function (event, reason, closed) {
        if (reason !== 'ok') {
            return onClose(event);
        }
    });

    function onClose(event) {
        if (vm.taxForm && vm.taxForm.$dirty) {
            event.preventDefault();
            $uibModal.open({
                ...InfoModal,
                resolve: {
                    notification: () => "Your form is not completed yet. Do you want to leave?",
                    state: () => "application-status"
                },
                controller: function ConfirmModalController($uibModalInstance) {
                    'ngInject'
                    this.close = function () {
                        $uibModalInstance.dismiss();
                    };
                },
                size: 'sm',
                backdrop: 'static'
            }).result.then(function (data) {
                if (data === 'ok') {
                    vm.close({ $value: 'ok' });
                }
            }, function (dismiss) {
                console.log(dismiss);
            });
        }
    }

    function onShowI9() {
        vm.close({ $value: 'ok' });
    }

    function retrieveLocaleTranslations(localeID) {
        return localeService.retrieveLocaleTranslations(localeID).then(function (translations) {
            return translations;
        });
    }

    function retrieveLocale() {
        return localeService.retrieveLocales()
            .then(function (locales) {
                return locales.filter(function (locale) {
                    return locale.countryID === vm.employeeBankInfo.CountryID;
                })[0] || localeService.retrieveCurrentLocale();
            })
            .then(function (locale) {
                if (locale) {
                    return locale;
                }
            });
    }

    function formatSsn(ssn) {
        if (!ssn) return "";
        var digits = ("" + ssn).replace(/[^0-9]/g, "");
        if (digits.length !== 9) return ssn;
        var mask = vm.employeeBankInfo
            && vm.employeeBankInfo.Translations
            && vm.employeeBankInfo.Translations.SSNMask;
        if (mask === "000-000-000") {
            return digits.slice(0, 3) + "-" + digits.slice(3, 6) + "-" + digits.slice(6, 9);
        }
        return digits.slice(0, 3) + "-" + digits.slice(3, 5) + "-" + digits.slice(5, 9);
    }

    function revealSSNChar(ssn, char, i) {
        return i > 4;
    }
}

export const NCW4Modal = {
    component: "apexNCW4Modal",
    windowClass: 'xx-dialog pagespinner',
    size: 'lg',
    backdrop: 'static'
}
